import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CitationsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const CITATIONS_QUERY = graphql`
query NodeAllCitationsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Citations" } }) {
    nodes {
      data
    }
  }
}
`;

export const CitationsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(CITATIONS_QUERY), 'items')}>{children}</Provider>;
};
